<template>
  <v-content>
    <v-container fill-height fluid centered justify-center>
      <div class='div-main grey lighten-5 pa-4' style='width: 30em;'>
        <v-row justify='center'>
          <v-col v-if='getLogged' cols='12' sm='12'>
            <v-card class outlined tile>
              <v-toolbar color='blue-grey lighten-2' dark>
                <v-toolbar-title>OTP Token</v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <div class='text-center'>
                <img alt width='240' height='240' :src='codigoQR' style='text-align: center' />
              </div>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col md='12'>
                      <v-text-field name='otp' dense v-model='otp' label='OTP' style='text-align: center;'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if='!!getError' justify='center'>
                    <p class='red--text'>{{ getError }}</p>
                  </v-row>
                  <v-spacer></v-spacer>
                  <v-row justify='center'>
                    <v-btn color='blue darken-1' outlined text @click='validarOtp'>Validar Token</v-btn>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-else cols='12' sm='12'>
            <v-card class outlined tile>
              <v-toolbar color='blue-grey lighten-2' dark>
                <v-toolbar-title>Ingreso de Usuarios</v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col md='12'>
                      <v-text-field dense v-model='usuario' label='Usuario'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md='12'>
                      <v-text-field dense type='password' v-model='clave' label='Contraseña'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if='!!getError' justify='center'>
                    <p class='red--text'>{{ getError }}</p>
                  </v-row>
                  <v-row justify='center'>
                    <v-btn color='blue darken-1' outlined @click='ingresar'>Ingresar</v-btn>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-content>
</template>

<script>
    import qrcode from "qrcode";
    import { authenticator } from "otplib";

    import { mapMutations, mapGetters, mapActions } from "vuex";

    const OTP_SERVICIO = "apps.jetbox.com";

    export default {
        name: "login",
        data() {
            return {
                otp: "",
                clave: "",
                usuario: "",
                sep: "^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^",
                token0: "",
                token1: "",
                codigoQR: "",
            };
        },

        computed: {
            ...mapGetters(["getError", "getLogged", "getOtpHash"])
        },
        created() {
            if (process.env.NODE_ENV === 'development') {
                this.usuario = 'taliki'
                this.clave = '123456789'
            }
        },
        methods: {
            ...mapActions(["doLogin", "doOtp"]),
            ...mapMutations(["CAMBIAR_USER", "CAMBIAR_LOGGED", "CAMBIAR_ERROR"]),
            async ingresar() {
                await this.doLogin({ usuario: this.usuario, clave: this.clave });
                this.iniciarOtp();
                if (process.env.NODE_ENV === 'development') {
                    this.otp = this.token1;
                }
            },
            validarOtp() {
                if (this.otp === this.token0 || this.otp === this.token1) {
                    this.doOtp();
                } else {
                    this.CAMBIAR_ERROR("OTP incorrecto!");
                }
            },
            iniciarOtp() {
                if (this.getLogged && this.getOtpHash) {
                    this.otpURL = authenticator.keyuri(
                        this.usuario,
                        OTP_SERVICIO,
                        this.getOtpHash
                    );
                    this.token0 = this.token1 = authenticator.generate(this.getOtpHash);

                    qrcode.toDataURL(this.otpURL, (err, imageUrl) => {
                        if (err) {
                            console.log("Error with QR");
                            return;
                        }
                        this.codigoQR = imageUrl;
                    });
                    setInterval(() => {
                        const token = authenticator.generate(this.getOtpHash);

                        if (token != this.token1) {
                            this.token0 = this.token1;
                            this.token1 = token;
                        }
                    }, 1000);
                }
            },
            olvidoContrasena() {
                alert("auch");
            }
        },

        mounted() {
            this.CAMBIAR_ERROR("");
            this.CAMBIAR_LOGGED(false);
        }
    };
</script>

<style scoped>
    div.main {
        background-image: url("https://jetbox.com/");
    }
    /deep/ a.olvido-clave {
        color: coral;
        margin: -1em 0 1.44rem 0;
    }
    /deep/ a.registrarse {
        color: cadetblue;
        margin: 1rem 0;
    }
    /deep/ input[name="otp"] {
        text-align: center;
    }
</style>